
import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import avtar5 from '../../assets/images/user/avatar-5.jpg'
import { getData, postData } from '../Services/api'
import { toast } from 'react-toastify'
import JoditEditor from 'jodit-react';

const AddCategory = () => {
    const editor = useRef(null);
    const [parentCategories, setParentCategories] = useState([]);
    const [values, setValues] = useState({
        cat_name: "",
        description: "",
        cat_image: null,
        parentId: ""
    })

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const handleChange = async (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    };

    const loadParentCategories = async () => {
        try {
            const res = await getData("/category/parents");
            if (res.status) {
                setParentCategories(res.data);
            }
        } catch (error) {
            console.log("Error loading parent categories");
        }
    };

    useEffect(() => {
        loadParentCategories();
    }, []);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setValues(prev => ({
                ...prev,
                cat_image: file,
            }));
        }
    };

    const validateCategory = () => {
        const { cat_name, description } = values;

        if (!cat_name.trim()) {
            toast.dismiss();
            toast.error("Category name is required.");
            return false;
        }

        if (!description.trim()) {
            toast.dismiss();
            toast.error("Description is required.");
            return false;
        }

        return true;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateCategory()) return;
        setLoading(true)
        try {
            const formData = new FormData();
            formData.append('cat_name', values.cat_name);
            formData.append('description', values.description);

            if (values.parentId) {
                formData.append("parentId", values.parentId);
            }
            if (values.cat_image) {
                formData.append('cat_image', values.cat_image);
            }
            const res = await postData('/category/add', formData);
            if (res.status) {
                toast.success(res.message)
                navigate('/categories/category-list');
                setValues({
                    cat_name: "",
                    description: "",
                    cat_image: null,
                    parentId: ""
                })
            }
        } catch (error) {
            console.log("error category adding",)
            toast.error(error.data.response.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/categories/category-list">Category</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Add Category
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Add Category</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Add Category</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-sm-6 mb-3">
                                                <label htmlFor="cat_image" className="form-label">
                                                    Category Image
                                                </label>

                                                <input
                                                    type="file"
                                                    id="cat_image"
                                                    className="form-control"
                                                    onChange={handleImageChange}
                                                    accept="image/*"
                                                />

                                                {values.cat_image && (
                                                    <img
                                                        src={URL.createObjectURL(values.cat_image)}
                                                        alt="Preview"
                                                        className="img-fluid mt-2"
                                                        style={{ maxWidth: "150px", borderRadius: "8px" }}
                                                    />
                                                )}
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Category Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Category Name"
                                                        name='cat_name'
                                                        value={values.cat_name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            {/* PARENT CATEGORY */}
                                            <div className="col-md-12 mt-3">
                                                <label className="form-label">Select Parent Category (Optional)</label>
                                                <select
                                                    className="form-control"
                                                    name="parentId"
                                                    value={values.parentId}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">-- No Parent (Top Category) --</option>

                                                    {parentCategories.map((cat) => (
                                                        <option key={cat._id} value={cat._id}>
                                                            {cat.cat_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-12 mt-3">
                                                <div className="form-group">
                                                    <label className="form-label">Description</label>
                                                    <JoditEditor
                                                        ref={editor}
                                                        value={values.description}
                                                        onChange={(newContent) =>
                                                            setValues(prev => ({
                                                                ...prev,
                                                                description: newContent
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <Link to="/categories/category-list" className="btn btn-outline-secondary">Cancel</Link>
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddCategory